import React from 'react';
import { Form, Input, Switch } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import { TimePicker, DatePicker } from 'components/common/dates';
import { InputTypes } from '../helpers';
import NumericInput from './NumericInput';

interface ChildProps {
  disabled: boolean
}

interface InputProps {
  max?: number | string;
  maxLength?: number;
  min?: number | string;
  minLength?: number;
  placeholder?: string;
  step?: number;
  readOnly?: boolean;
  required?: boolean;
}

interface FormInputProps extends FormItemProps, InputProps {
  name?: string;
  label?: string;
  type?: InputTypes;
  disabled?: boolean;
  suffix?: string;
  mask?: string;
}

export const FormInput: React.FC<FormInputProps> = (props) => {
  let { disabled, type, suffix, mask, children, ...rest } = props;
  let { max, maxLength, min, minLength, placeholder, step, readOnly, required, ...itemProps } = rest;
  
  placeholder = placeholder || itemProps.label;
  const inputProps: InputProps = { 
    max, maxLength, min, minLength, placeholder, step, readOnly, required
  };
  let valuePropName = (type === 'switch') ? 'checked' : 'value';

  const renderControl = (controlType: InputTypes, childProps: ChildProps) => {
    switch (controlType) {
      case 'time':
        return <TimePicker {...childProps} format='hh:mm A' minuteStep={10} />;
      case 'date':
        return <DatePicker {...childProps} format='YYYY/MM/DD' style={{ width: '100%' }} />;
      case 'switch':
        return <Switch {...childProps} />;
      case 'numeric':
        return <NumericInput placeholder={placeholder || '0.00'} {...childProps} {...inputProps} />;
      case 'percent':
        return <Input type="number" placeholder="0.00" suffix="%" {...childProps} min={0} max={100} {...inputProps} />;
      case 'number':
        return <Input type="number" placeholder={placeholder || '0.00'} {...childProps} min={0} {...inputProps} />;
      case 'textarea':
        return <Input.TextArea {...childProps} {...inputProps} />;
      default:
        return <Input type={controlType} suffix={suffix} {...childProps} {...inputProps} />;
    }
  };

  return (
    <Form.Item {...props} valuePropName={valuePropName}>
      {renderControl(type, { disabled })}
    </Form.Item>
  );
};

export type { InputProps };
